import { useEffect, useRef } from "react";
import { useAuth } from "@babackapp/auth-client/hooks";

export default function ForceLogout() {
  const isLoggingOut = useRef(false);
  const auth = useAuth();

  useEffect(() => {
    if (isLoggingOut.current) return;
    isLoggingOut.current = true;

    const performLogout = async () => {
      // Vider le localStorage
      localStorage.clear();

      // Supprimer tous les cookies
      document.cookie.split(";").forEach((c) => {
        const [cookieName] = c.split("=");
        const name = cookieName.trim();
        // Supprimer pour différents chemins et domaines
        const paths = ["/", "/auth", "/auth/", "/auth/session/refresh"];
        const domains = [
          window.location.hostname,
          `.${window.location.hostname}`,
          '.baback.co'
        ];

        paths.forEach((path) => {
          domains.forEach((domain) => {
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path};domain=${domain};`;
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path};`;
          });
        });
      });

      // Will also redirect to the sign-in page
      await auth.logout();
    };

    performLogout();
  }, []);

  return null;
}
